module.exports = __webpack_public_path__ + "static/media/ted.036c0f91.jpg";